<template>
  <div class="dropdown">
    <div class="accordion down-sell-widgets" id="accordionExample">
      <div>
        <div class="card-header-people">
          <h2 class="mb-0">
            <button 
              class="btn btn-block text-left text-uppercase d-flex align-items-center justify-content-between btn-people" 
              type="button" 
              data-toggle="collapse" 
              :aria-expanded="isOpen" 
              aria-controls="collapseDownsell"
              @click="toggleDropdown">
              <span class="heading-title">SELECT REASON FOR PURCHASE</span>
              <i style="cursor:pointer;" class="custom-icon" :class="isOpen ? 'fa fa-angle-up fa-lg' : 'fa fa-angle-down fa-lg'" aria-hidden="true"></i>
            </button>
          </h2>
        </div>
        <div id="collapseDownsell" class="collapse" :class="{ show: isOpen }" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body px-2">
            <label class="custom-radio w-100" v-for="(item, index) in options" :key="index">
              <div class="radio-item d-flex align-items-center p-0">
                <input class="radio-button" :id="item.id" name="radio" type="radio" @click="selectOption(item)">
                <p class="m-0 pl-2">{{ item.name }}</p>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      isOpen: false,
      selectedValue: this.value
    }
  },
  methods: {
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },
    selectOption (option) {
      this.$emit('input', option)
      this.selectedValue = option
    }
  },
  watch: {
    value (newValue) {
      this.selectedValue = newValue
    }
  }
}
</script>

<style scoped>
.dropdown {
  padding: 8px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(167, 169, 172, 0.22);
}
.btn-people {
  background-color: #fff;
  padding: 0px;
  cursor: pointer;
}
.card-header-people {
  background-color: #fff;
  border-bottom: none;
}
.card-body {
  padding: 0;
}
.custom-radio {
  margin-bottom: 8px;
}
.radio-item {
  width: 100%;
  padding: 8px;
  cursor: pointer;
}
.radio-button {
  accent-color: #117a7a; /* This is for modern browsers */
}
.radio-button:checked {
  background-color: #117a7a; 
  border-color: #117a7a; 
}
.heading-title {
  color: #707070;
  font-size: 15px;
  font-weight: 600;
}
@media screen and (max-width: 767px) {
  .heading-title {
    color: #282c3f; 
    padding-left: 6px;
  }
  .custom-icon {
    padding-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// Dropdown.vue?142c8614